export default "__VITE_ASSET__3107cbfe__"